// extracted by mini-css-extract-plugin
module.exports = {"EditorIntro":"_1pZsDnjP","titleBlock":"_2-Ykguxw","title":"_23oJyu1y","titleContainer":"_1N595jq0","mainBlock":"_3QvPwF3M","instructionsBlock":"_2R8z3lwR","instructionsHead":"_1N17YXED","player":"_13nRxFlE","delete":"_3eYvtFXv","modal":"QSTjeL3C","modalContent":"_10f9zzCg","modalButtons":"_3NM-j0k8","emptyVideo":"_1ZNbYN3u"};
    if(module.hot) {
      // 1754515036793
      var cssReload = require("!../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  